import {
  Box,
  Heading,
  Hidden,
  Stack,
  Text,
  Actions,
  PageBlock,
} from 'braid-design-system';
import type { ComponentProps } from 'react';

import { seekBlueLight800 } from 'src/theme';

import * as styles from './Banner.css';

export const Banner = ({
  heading,
  subHeading,
  actions,
}: {
  heading: ComponentProps<typeof Heading>['children'];
  subHeading: ComponentProps<typeof Text>['children'];
  actions: ComponentProps<typeof Actions>['children'];
}) => (
  <PageBlock width="medium">
    <Box
      position="relative"
      style={{ background: seekBlueLight800 }}
      background="customDark"
      borderRadius="large"
      paddingY={['large', 'large', 'xxlarge']}
      paddingX={['medium', 'medium', 'xxlarge']}
      overflow="hidden"
    >
      <Stack space="large" align="center">
        <Heading level="3" align="center">
          {heading}
        </Heading>
        <Text size="large" align="center">
          {subHeading}
        </Text>
        <Actions>{actions}</Actions>
      </Stack>

      <Hidden below="desktop">
        <svg
          width="51"
          height="52"
          viewBox="0 0 51 52"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.topAlmostRightShape}
        >
          <path
            d="M50.9873 1.01294L50.9873 51.0129C23.3731 51.0129 0.987303 28.6272 0.987303 1.01295C0.987303 1.00432 0.987305 0.995693 0.987309 0.987064L0.987309 1.01294L50.9873 1.01294Z"
            fill="currentColor"
          />
        </svg>
        <svg
          width="150"
          height="150"
          viewBox="0 0 150 150"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.bottomRightShape}
        >
          <path
            d="M150 150L0 150C3.62117e-06 67.1573 67.1573 -3.62117e-06 150 0V150Z"
            fill="currentColor"
          />
        </svg>
      </Hidden>
    </Box>
  </PageBlock>
);
